var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center mb-6"},[(_vm.onBack)?_c('v-btn',{staticClass:"me-2",attrs:{"icon":""},on:{"click":_vm.onBack}},[_c('v-icon',[_vm._v("mdi-arrow-left")])],1):_vm._e(),_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }